import * as angular from "angular";
import {IController} from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ServicePointsAlerts} from "../../services/service-points-alerts.service";
import {ServicePointsRequests} from "../../services/service-points-requests.service";
import {ServicePointsService} from "../../services/service-points.service";
import {ServicePointsDialogService} from "../../services/service-points-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ServicePointsViewCtrl implements IController {

  private doReload: any;
  private filtersConfig: any;
  public branchIds: any[];
  private servicePointsRef: any;
  private loadLimit: any;
  public infiniteScroll: any;
  public sortField: string = 'name';
  public sortDirection: string = 'asc';

  /* @ngInject */
  constructor(private servicePointsRequests: ServicePointsRequests, private confirmDialogService: ConfirmDialogService,
              private bringozLoaderService: BringozLoaderService, private $log, private servicePointsAlerts: ServicePointsAlerts,
              private servicePointsService: ServicePointsService, private servicePointsDialogService: ServicePointsDialogService,
              private $servicePoints, private $infiniteScroll) {
  }

  $onInit() {
    this.doReload = false;
    this.filtersConfig = {
      queryString: undefined
    };
    this.branchIds = [];

    this.servicePointsRef = this.$servicePoints();
    this.loadLimit = 30;

    this.servicePointsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.servicePointsRef, this.loadLimit, {getFullData: true});
  }

  submitQuery(query) {
    this.filtersConfig.queryString = query;
    this._reloadQuery();
  }

  onBranchIdsChange(selectedIds) {
    this.branchIds = selectedIds;
    this._reloadQuery();
  }

  onReloadFinished() {
    this.doReload = false;
  }

  onToggleSort(sortField, sortDirection) {
    this.sortField = sortField;
    this.sortDirection = sortDirection;
    this._reloadQuery();
  }

  private _reloadQuery() {
    this.servicePointsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      query: this.filtersConfig.queryString,
      branchIds: this.branchIds,
      limit: this.loadLimit,
      sort: this._getSortType()
    }
  }

  private _getSortType() {
    if (this.sortField) {
      return this.sortField + ',' + this.sortDirection;
    } else {
      return undefined;
    }
  }

  onCreateServicePoint(event) {
    this.servicePointsDialogService.openServicePointDialog(event, 'create', undefined)
      .then((servicePointToCreate) => {
        return this.servicePointsService.createServicePoint(servicePointToCreate)
      })
      .then(() => {
        this._reloadQuery();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to create service point @servicePointsView@onCreateServicePoint', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onImportServicePoints(event) {
    this.servicePointsDialogService.openImportServicePointsDialog(event)
      .then(() => {
        this._reloadQuery();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to import service points @servicePointsView@onImportServicePoints', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onDeleteServicePoint(servicePoint, event) {
    let isDeleting = false;
    const text = 'Are you sure you want to delete this service point?';
    this.confirmDialogService.confirmMask('Delete Service Point', text, event)
      .then((shouldMask) => {
        isDeleting = true;
        this.bringozLoaderService.on();
        return this.servicePointsRequests.deleteServicePoint(servicePoint.id, shouldMask)
      })
      .then((res) => {
        this._reloadQuery();
        this.servicePointsAlerts.deleteSuccess(servicePoint);
      })
      .catch((error) => {
        if (error) {
          this.servicePointsAlerts.deleteError();
          this.$log.error('Failed to delete service point @servicePointsView@onDeleteServicePoint', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (isDeleting) {
          this.bringozLoaderService.off();
        }
      })
  }

  onEdit(servicePoint, event) {
    this.servicePointsDialogService.openServicePointDialog(event, 'update', servicePoint)
      .then((servicePointToUpdate) => {
        return this.servicePointsService.updateServicePoint(servicePointToUpdate);
      })
      .then(() => {
        this._reloadQuery();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to update service point @servicePointsView@onEdit', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

}

angular
  .module('bringoz.admin.service-points')
  .component('servicePointsView', {
    bindings: {
    },
    template: require('./service-points-view.html').default,
    controller: ServicePointsViewCtrl
  });
